/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface PCPSameAsReferrer {
  status: "same_as_referrer";
  responded_at?: string | null;
}
